import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

type TagType = "success" | "default";

interface TagProps {
  /** 预设配色：success 绿 / default 灰（默认 default） */
  type?: TagType;
  /** 自定义类名（可覆盖间距等） */
  className?: string;
  children?: React.ReactNode;
}

/**
 * 小标签（标题旁的说明标签，如「多选」「选填」）。
 * 统一盒模型（圆角/内边距/字号），配色由 type 决定。
 */
export default function Tag({ type = "default", className, children }: TagProps) {
  return (
    <span className={classNames(styles.tag, styles[type], className)}>
      {children}
    </span>
  );
}
